import { RouteConfig } from 'vue-router';

import { AttachmentType } from '@/enums/attachmentType.enum';
import { EntityType } from '@/enums/entityType.enum';
import { Errors } from '@/enums/errors.enum';
import { ProcedureInstance } from '@/enums/procedureInstance.enum';
import { TableName } from '@/enums/tableName';
import { DocumentIndex } from '@/interfaces/documentIndex';
import store from '@/store/store';
import { config } from '@/utils/config';
import { tryParseInt } from '@/utils/number';

export const documentDocumentationRoute: RouteConfig = {
  name: 'documentDocumentation',
  path: 'documentation',
  component: () =>
    import(/* webpackChunkName: "DocumentDocumentation" */ '@/views/mainRoute/document/details/Documentation.vue'),
  meta: {},
  beforeEnter: (to, from, next) =>
    Promise.all([
      store
        .dispatch('documentIndex/get', tryParseInt(to.params.documentId))
        .then((document: DocumentIndex) => store.dispatch('view/listByStatusOption', { statusId: document.statusId })),
      store.dispatch('document/attachment/list', {
        order: 'order',
        desc: false,
        count: -1,
        entityType: EntityType.DOCUMENT,
        entityId: to.params.documentId.toString(),
        type: AttachmentType.GENERATED
      }),
      store.dispatch(
        'auth/checkPermissions',
        [
          'ATTACHMENT.ADD',
          config.procedure === ProcedureInstance.DUPLICATES
            ? `ATTACHMENT.ADD:${TableName.document}:${to.params.documentId}`
            : undefined
        ].filter(Boolean)
      )
    ])
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.ATTACHMENT_CANNOT_LIST }))
};
